export default "__VITE_ASSET__DdivdF1t__"